import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-piece-show',
  templateUrl: './piece-show.component.html',
  styleUrls: ['./piece-show.component.scss']
})
export class PieceShowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
